interface InstagramLinkButtonProps {
  /** Instagram の URL。未設定/空なら非公開・削除済み扱いでグレーの無効表示にする */
  href?: string | null
}

/**
 * 「Instagramで見る」共通ボタン。
 * href があればオレンジのプライマリボタン（外部リンク）として、
 * href が無ければ非公開/削除済みとしてグレーの無効表示（クリック不可）を描画する。
 * スタイルは `.instagram-link-btn`（analytics.scss / DESIGN.md Primary 準拠）。
 */
const InstagramLinkButton = ({ href }: InstagramLinkButtonProps) => {
  const label = (
    <>
      Instagramで見る
      <i className="bi bi-box-arrow-up-right" aria-hidden="true" />
    </>
  )

  if (!href) {
    return (
      <span className="instagram-link-btn instagram-link-btn--disabled" aria-disabled="true">
        {label}
      </span>
    )
  }

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="instagram-link-btn">
      {label}
    </a>
  )
}

export default InstagramLinkButton
